import axios from 'axios'
import { API_URL } from '@/config'

export default {
  list() {
    return axios.get(`${API_URL}/roles`)
  },

  create(data) {
    return axios.post(`${API_URL}/roles`, data)
  },

  update (id, data) {
    return axios.put(`${API_URL}/roles/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${API_URL}/roles/${id}`)
  }

}
